(()=>{
const menuButton=document.querySelector('.menu-btn');
const navigation=document.querySelector('.nav');
if(menuButton&&navigation){
  menuButton.addEventListener('click',()=>{
    const isOpen=navigation.classList.toggle('open');
    menuButton.setAttribute('aria-expanded',String(isOpen));
  });
}

document.querySelectorAll('[data-year]').forEach(element=>{
  element.textContent=new Date().getFullYear();
});

document.addEventListener('click',event=>{
  document.querySelectorAll('details.more[open]').forEach(details=>{
    if(!details.contains(event.target)) details.removeAttribute('open');
  });
});

const animalTriggers=[...document.querySelectorAll('.animal-hotspot')];
let activeAnimalTrigger=null;
let hoverCloseTimer=null;

function cardFor(trigger){
  const cardId=trigger?.getAttribute('aria-controls');
  return cardId?document.getElementById(cardId):null;
}

function closeAnimalFact(trigger,{returnFocus=false}={}){
  if(!trigger) return;
  const card=cardFor(trigger);
  trigger.classList.remove('is-open');
  trigger.dataset.locked='false';
  trigger.setAttribute('aria-expanded','false');
  if(card){
    card.hidden=true;
    card.setAttribute('aria-hidden','true');
  }
  if(activeAnimalTrigger===trigger) activeAnimalTrigger=null;
  if(returnFocus){
    trigger.dataset.suppressFocus='true';
    trigger.focus({preventScroll:true});
    window.requestAnimationFrame(()=>{trigger.dataset.suppressFocus='false';});
  }
}

function closeAllAnimalFacts(except=null){
  animalTriggers.forEach(trigger=>{
    if(trigger!==except) closeAnimalFact(trigger);
  });
}

function openAnimalFact(trigger,{locked=false}={}){
  const card=cardFor(trigger);
  if(!card) return;
  window.clearTimeout(hoverCloseTimer);
  closeAllAnimalFacts(trigger);
  activeAnimalTrigger=trigger;
  trigger.classList.add('is-open');
  trigger.dataset.locked=locked?'true':'false';
  trigger.setAttribute('aria-expanded','true');
  card.hidden=false;
  card.setAttribute('aria-hidden','false');
}

function scheduleHoverClose(trigger){
  window.clearTimeout(hoverCloseTimer);
  hoverCloseTimer=window.setTimeout(()=>{
    const card=cardFor(trigger);
    const isLocked=trigger.dataset.locked==='true';
    const pointerStillInside=trigger.matches(':hover')||Boolean(card?.matches(':hover'));
    if(!isLocked&&!pointerStillInside) closeAnimalFact(trigger);
  },220);
}

animalTriggers.forEach(trigger=>{
  const card=cardFor(trigger);
  if(!card) return;
  trigger.dataset.locked='false';

  trigger.addEventListener('pointerenter',event=>{
    if(event.pointerType==='mouse') openAnimalFact(trigger,{locked:false});
  });
  trigger.addEventListener('pointerleave',event=>{
    if(event.pointerType==='mouse') scheduleHoverClose(trigger);
  });
  trigger.addEventListener('focus',()=>{
    if(trigger.dataset.suppressFocus==='true') return;
    openAnimalFact(trigger,{locked:false});
  });
  trigger.addEventListener('click',event=>{
    event.preventDefault();
    event.stopPropagation();
    const lockedOpen=trigger.classList.contains('is-open')&&trigger.dataset.locked==='true';
    if(lockedOpen){
      closeAnimalFact(trigger);
    }else{
      openAnimalFact(trigger,{locked:true});
    }
  });
  trigger.addEventListener('keydown',event=>{
    if(event.key!=='Enter'&&event.key!==' ') return;
    event.preventDefault();
    event.stopPropagation();
    const lockedOpen=trigger.classList.contains('is-open')&&trigger.dataset.locked==='true';
    if(lockedOpen){
      closeAnimalFact(trigger);
    }else{
      openAnimalFact(trigger,{locked:true});
    }
  });

  card.addEventListener('pointerenter',()=>window.clearTimeout(hoverCloseTimer));
  card.addEventListener('pointerleave',()=>scheduleHoverClose(trigger));
  card.addEventListener('click',event=>event.stopPropagation());
  card.querySelector('.animal-card-close')?.addEventListener('click',()=>{
    closeAnimalFact(trigger,{returnFocus:true});
  });
});

document.addEventListener('focusin',event=>{
  if(!activeAnimalTrigger) return;
  const activeCard=cardFor(activeAnimalTrigger);
  const focusedInside=activeAnimalTrigger.contains(event.target)||Boolean(activeCard?.contains(event.target));
  if(!focusedInside&&!event.target.closest('.animal-hotspot')) closeAnimalFact(activeAnimalTrigger);
});

document.addEventListener('click',event=>{
  if(!activeAnimalTrigger) return;
  const activeCard=cardFor(activeAnimalTrigger);
  if(!activeAnimalTrigger.contains(event.target)&&!activeCard?.contains(event.target)){
    closeAnimalFact(activeAnimalTrigger);
  }
});

document.addEventListener('keydown',event=>{
  if(event.key==='Escape'&&activeAnimalTrigger){
    closeAnimalFact(activeAnimalTrigger,{returnFocus:true});
  }
});

})();
